// Hermes theme store — holds the light/dark preference and mirrors it onto
// `<html data-theme="…">` so the `[data-theme="dark"]` token block in
// `_tokens.scss` takes effect.
//
// Persisted via pinia-plugin-persistedstate (registered in index.js), so the
// choice survives reloads. Default is light. `init()` is called once at boot
// (index.js) to stamp the attribute for the persisted value; `set()` / `toggle()`
// re-stamp on change. HermesThemeToggle drives it.

import { defineStore } from 'pinia';

function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (theme === 'dark') {
    root.setAttribute('data-theme', 'dark');
  } else {
    // Light is the absence of the attribute — keeps the default :root block.
    root.setAttribute('data-theme', 'light');
  }
}

export const useThemeStore = defineStore('hermesTheme', {
  state: () => ({
    // 'light' | 'dark'
    theme: 'light',
  }),

  getters: {
    isDark: (state) => state.theme === 'dark',
  },

  actions: {
    // Stamp the attribute for whatever value was rehydrated from storage.
    // Safe to call more than once.
    init() {
      applyTheme(this.theme);
    },
    set(theme) {
      this.theme = theme === 'dark' ? 'dark' : 'light';
      applyTheme(this.theme);
    },
    toggle() {
      this.set(this.theme === 'dark' ? 'light' : 'dark');
    },
  },

  persist: true,
});

export default useThemeStore;
